// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/PFAgoraSlabPro-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/SuisseIntl-Book.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'FAgoraSlabPro';
    src: local('FAgoraSlabPro'),
      url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  }

@font-face {
    font-family: 'SuisseIntl';
      src: local('SuisseIntl'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  }

  :root[data-theme="light"] {
    --color-text: #393939;
  }
  
  :root[data-theme="dark"] {
    --color-text:  #ffffff;
  }
  

.App
{
  User-select: none;
  margin-top: 5%;
  align-items: center;
  width: auto;
  height: auto;
  overflow-x:hidden;
}

.post
{
  color: var(--color-text);
  text-align: center;
  font-family: "FAgoraSlabPro";
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 38px; 
  display: flex;
}

.textBox
{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}


.buttonSend
{
  position: relative;
  top: 50px;
  display: flex;

}

.stars
{
  gap: 20px; 
  align-self: center;
  align-items: center;
  display: flex;

}

.header
{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: -36px;
}

.headerSvgStyle
{
  display: flex;
flex-direction: column;
align-items: center;
width: 135px;
height: 106px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B;gEAC4D;EAC9D;;AAEF;IACI,yBAAyB;MACvB;kEACuD;EAC3D;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;EAEE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;;AAGA;;EAEE,kBAAkB;EAClB,SAAS;EACT,aAAa;;AAEf;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;;AAEf;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf,sBAAsB;AACtB,mBAAmB;AACnB,YAAY;AACZ,aAAa;AACb","sourcesContent":["@font-face {\r\n    font-family: 'FAgoraSlabPro';\r\n    src: local('FAgoraSlabPro'),\r\n      url('./fonts/PFAgoraSlabPro-Black.ttf') format('truetype');\r\n  }\r\n\r\n@font-face {\r\n    font-family: 'SuisseIntl';\r\n      src: local('SuisseIntl'),\r\n        url('./fonts/SuisseIntl-Book.otf') format('truetype');\r\n  }\r\n\r\n  :root[data-theme=\"light\"] {\r\n    --color-text: #393939;\r\n  }\r\n  \r\n  :root[data-theme=\"dark\"] {\r\n    --color-text:  #ffffff;\r\n  }\r\n  \r\n\r\n.App\r\n{\r\n  User-select: none;\r\n  margin-top: 5%;\r\n  align-items: center;\r\n  width: auto;\r\n  height: auto;\r\n  overflow-x:hidden;\r\n}\r\n\r\n.post\r\n{\r\n  color: var(--color-text);\r\n  text-align: center;\r\n  font-family: \"FAgoraSlabPro\";\r\n  font-size: 28px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 38px; \r\n  display: flex;\r\n}\r\n\r\n.textBox\r\n{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 24px;\r\n}\r\n\r\n\r\n.buttonSend\r\n{\r\n  position: relative;\r\n  top: 50px;\r\n  display: flex;\r\n\r\n}\r\n\r\n.stars\r\n{\r\n  gap: 20px; \r\n  align-self: center;\r\n  align-items: center;\r\n  display: flex;\r\n\r\n}\r\n\r\n.header\r\n{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: -36px;\r\n}\r\n\r\n.headerSvgStyle\r\n{\r\n  display: flex;\r\nflex-direction: column;\r\nalign-items: center;\r\nwidth: 135px;\r\nheight: 106px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
